import { CONTENT } from '@/clients'
import { rmotrErrorHandler } from '@/helpers'

/**
 * Retrieve Lab
 * @param {UUID} labId
 */
const fetchLab = async labId => {
  const route = `labs/${labId}`
  return CONTENT.get(route)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(rmotrErrorHandler(error)))
}

/**
 * Create Lab session
 * @param {UUID} labId
 */
const postLabSession = async labId => {
  const route = `labs/${labId}/sessions`
  return CONTENT.post(route)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(rmotrErrorHandler(error)))
}

/**
 * Create Lab ping
 * @param {UUID} labId
 */
const postLabPing = async labId => {
  const route = `labs/${labId}/ping`
  return CONTENT.post(route)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(rmotrErrorHandler(error)))
}

/**
 * Retrieve Lab session
 * @param {object} labAndSessionId
 * @param {UUID} labAndSessionId.labId
 * @param {UUID} labAndSessionId.sessionId
 */
const fetchLabSession = async labAndSessionId => {
  const { labId, sessionId } = labAndSessionId
  const route = `labs/${labId}/sessions/${sessionId}`
  return CONTENT.get(route)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(rmotrErrorHandler(error)))
}

/**
 * Patch Lab session
 * @param {object} sessionDetails
 * @param {UUID} sessionDetails.labId
 * @param {UUID} sessionDetails.sessionId
 * @param {UUID} sessionDetails.status
 */
const patchLabSession = async sessionDetails => {
  const { labId, sessionId, status } = sessionDetails
  const route = `labs/${labId}/sessions/${sessionId}`
  const payload = {
    status,
  }
  return CONTENT.patch(route, payload)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(rmotrErrorHandler(error)))
}

/**
 * Retrieve Lab session VPN configuration file
 * @param {object} labAndSessionId
 * @param {UUID} labAndSessionId.labId
 * @param {UUID} labAndSessionId.sessionId
 */
const fetchLabSessionVPNFile = async labAndSessionId => {
  const { labId, sessionId } = labAndSessionId
  const route = `labs/${labId}/sessions/${sessionId}/vpn-config`
  return CONTENT.get(route)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(rmotrErrorHandler(error)))
}

export {
  fetchLab,
  postLabPing,
  postLabSession,
  fetchLabSession,
  patchLabSession,
  fetchLabSessionVPNFile,
}
